import React, { useMemo } from 'react';
import { useUser } from '../../../contexts/UserContext';
import './UserWelcomeInfo.scss';

const UserWelcomeInfo = () => {
  const { user } = useUser();

  const displayName = useMemo(() => {
    const firstName = user?.firstName || '';
    if (firstName) return firstName;
    if (user?.name) return user.name;
    if (user?.email) return user.email.split('@')[0];
    return 'User';
  }, [user]);
  // Get current date and format it
  const getCurrentDate = () => {
    const now = new Date();
    const options = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return now.toLocaleDateString('en-US', options);
  };

  return (
    <div className="user-welcome-info">
      <div className="welcome-text">Welcome, {displayName}</div>
      <div className="date-text">{getCurrentDate()}</div>

    </div>
  );
};

export default UserWelcomeInfo;
